// ----------------------------------------------------------------------

export default function Accordion(theme) {
  if (theme.mode === 'light') return {};

  return {
    MuiAccordion: {
      styleOverrides: {
        root: {
          background: "rgba(25, 30, 35, 0.3)", // Slightly lighter dark background for contrast
          backdropFilter: "blur(3px) saturate(150%)", // Moderate blur for smooth glass effect
          WebkitBackdropFilter: "blur(3px) saturate(150%)",
          boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)", // Low subtle shadow
          borderRadius: Number(theme.shape.borderRadius) * 2,
          '&.Mui-expanded': {
            // boxShadow: theme.customShadows.z8,
            borderRadius: Number(theme.shape.borderRadius) * 2,
          },
          "&:not(.Mui-expanded)": {
            borderTop: "none", // Remove top border when collapsed
          },
          '&.Mui-disabled': {
            backgroundColor: 'transparent',
          },
          // Targeting the ::before pseudo-element
          "&::before": {
            content: '""',
            display: "none", // Remove border-top when collapsed
          },
          "&.Mui-expanded::before": {
            display: "block", // Show border when expanded
            borderTop: "1px solid rgba(255, 255, 255, 0.2)", // Border for expanded state
          },
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          paddingLeft: theme.spacing(2),
          paddingRight: theme.spacing(1),
          '&.Mui-disabled': {
            opacity: 1,
            color: theme.palette.action.disabled,
            '& .MuiTypography-root': {
              color: 'inherit',
            },
          },
        },
        expandIconWrapper: {
          color: 'inherit',
        },
      },
    },
  };
}
